export const T = {
  en_GB: {
    title: "Compliance Review",
    description: (name: string) =>
      `Record a compliance check on ${name}. This does not change the flow's process.`,
    stepNotReviewed: "Not reviewed",
    stepFlagged: "Flagged for review",
    stepApproved: "Approved",
    logTitle: "Review history",
    logEmpty: "Nothing recorded yet.",
    logEntry: (by: string, at: string) => `${by} · ${at}`,
    actionFlag: "Flagged",
    actionRemark: "Remark",
    actionApprove: "Approved",
    notes: "Notes",
    notesPlaceholder: "What was reviewed, and what was found",
    notesRequired: "Required. A verdict without a reason is not evidence.",
    addRemark: "Add remark",
    approve: "Approve",
    close: "Close",
    hintNotReviewed: "Flag this flow for review from the list to start.",
    hintApproved: "This review is approved. Flag it again from the list to reopen it.",
  },
  nb_NO: {
    title: "Compliance-gjennomgang",
    description: (name: string) =>
      `Registrer compliance-kontroll på ${name}. Dette endrer ikke flytens prosess.`,
    stepNotReviewed: "Ikke vurdert",
    stepFlagged: "Flagget for vurdering",
    stepApproved: "Godkjent",
    logTitle: "Vurderingshistorikk",
    logEmpty: "Ingenting registrert ennå.",
    logEntry: (by: string, at: string) => `${by} · ${at}`,
    actionFlag: "Flagget",
    actionRemark: "Merknad",
    actionApprove: "Godkjent",
    notes: "Notater",
    notesPlaceholder: "Hva ble vurdert, og hva ble funnet",
    notesRequired: "Påkrevd. En konklusjon uten begrunnelse er ikke dokumentasjon.",
    addRemark: "Legg til merknad",
    approve: "Godkjenn",
    close: "Lukk",
    hintNotReviewed: "Flagg denne flyten for vurdering fra listen for å starte.",
    hintApproved: "Denne vurderingen er godkjent. Flagg den på nytt fra listen for å gjenåpne.",
  },
} as const;
